<template src="./index.html"></template>

<script>
export default {
    props: {
        ApprovalProcess: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: function () {
                return [{}];
            }
        }
    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {
        splc() {
            this.$emit('splc', '');
        }
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>